import React from 'react';

const PlainLayout = ({ routeComponent: RouteComponent }) => {
  return <div>{RouteComponent}</div>;
};

export default PlainLayout;
